import React from "react";
import { Header, Sidebar, Footer } from ".";
import { TextColors } from "@utils/getTextColor";
import { processPageOptions } from "@utils/pageOptions";

const Layout = ({
  children,
  configs,
}: {
  children: React.ReactNode;
  configs?: PageOptions;
}) => {
  const options = processPageOptions(configs!);
  return (
    <div className="overflow-x-hidden">
      <Header textColor={options.text as string} logoOnly={options.logoOnly} />
      <Sidebar />
      <main>{children}</main>
      <Footer useLeadForm={options.useLeadForm ?? true} />
    </div>
  );
};

export default Layout;

export type PageOptions = {
  page_options__nav_text_color: { value: [{ codename: TextColors }] };
  page_options__logo_only_header: {
    value: [{ codename: "default" | "logo_only" }];
  };
  page_options__lead_form_controller: {
    value: [{ codename: "on" | "off" }];
  };
};
